import Component from './about'

export default Component